import { render, staticRenderFns } from "./BillAP.vue?vue&type=template&id=67c5a837"
import script from "./BillAP.vue?vue&type=script&lang=js"
export * from "./BillAP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports